/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AngemeldetRouteImport } from './routes/_angemeldet'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PasswortVergessenRouteImport } from './routes/passwort-vergessen'
import { Route as PasswortZuruecksetzenRouteImport } from './routes/passwort-zuruecksetzen'
import { Route as AngemeldetIndexRouteImport } from './routes/_angemeldet/index'
import { Route as AngemeldetSplatRouteImport } from './routes/_angemeldet/$'
import { Route as AngemeldetMitarbeiterRouteImport } from './routes/_angemeldet/_mitarbeiter'
import { Route as AngemeldetAnfragenRouteImport } from './routes/_angemeldet/anfragen'
import { Route as AngemeldetAssistentRouteImport } from './routes/_angemeldet/assistent'
import { Route as AngemeldetBuchenRouteImport } from './routes/_angemeldet/buchen'
import { Route as AngemeldetEinrichtungRouteImport } from './routes/_angemeldet/einrichtung'
import { Route as AngemeldetFreigabenRouteImport } from './routes/_angemeldet/freigaben'
import { Route as AngemeldetKampagnenRouteImport } from './routes/_angemeldet/kampagnen'
import { Route as AngemeldetKundenstimmenRouteImport } from './routes/_angemeldet/kundenstimmen'
import { Route as AngemeldetProfilRouteImport } from './routes/_angemeldet/profil'
import { Route as AngemeldetRedaktionsplanRouteImport } from './routes/_angemeldet/redaktionsplan'
import { Route as AngemeldetStatusRouteImport } from './routes/_angemeldet/status'
import { Route as AngemeldetStudioRouteImport } from './routes/_angemeldet/studio'
import { Route as AngemeldetVorbereitungRouteImport } from './routes/_angemeldet/vorbereitung'
import { Route as AngebotTokenRouteImport } from './routes/angebot.$token'
import { Route as BuchenSlugRouteImport } from './routes/buchen.$slug'
import { Route as BuchungTokenRouteImport } from './routes/buchung.$token'
import { Route as DrehplanTokenRouteImport } from './routes/drehplan.$token'
import { Route as ReviewTokenRouteImport } from './routes/review.$token'
import { Route as AngemeldetMitarbeiterAngeboteRouteImport } from './routes/_angemeldet/_mitarbeiter.angebote'
import { Route as AngemeldetMitarbeiterAufgabenRouteImport } from './routes/_angemeldet/_mitarbeiter.aufgaben'
import { Route as AngemeldetMitarbeiterBoardRouteImport } from './routes/_angemeldet/_mitarbeiter.board'
import { Route as AngemeldetMitarbeiterChatRouteImport } from './routes/_angemeldet/_mitarbeiter.chat'
import { Route as AngemeldetMitarbeiterEinstellungenRouteImport } from './routes/_angemeldet/_mitarbeiter.einstellungen'
import { Route as AngemeldetMitarbeiterErinnerungenRouteImport } from './routes/_angemeldet/_mitarbeiter.erinnerungen'
import { Route as AngemeldetMitarbeiterKalenderRouteImport } from './routes/_angemeldet/_mitarbeiter.kalender'
import { Route as AngemeldetMitarbeiterKalkulatorRouteImport } from './routes/_angemeldet/_mitarbeiter.kalkulator'
import { Route as AngemeldetMitarbeiterKundenRouteImport } from './routes/_angemeldet/_mitarbeiter.kunden'
import { Route as AngemeldetMitarbeiterOnboardingRouteImport } from './routes/_angemeldet/_mitarbeiter.onboarding'
import { Route as AngemeldetMitarbeiterProduktionenRouteImport } from './routes/_angemeldet/_mitarbeiter.produktionen'
import { Route as AngemeldetMitarbeiterTeamRouteImport } from './routes/_angemeldet/_mitarbeiter.team'
import { Route as AngemeldetMitarbeiterZustellungenRouteImport } from './routes/_angemeldet/_mitarbeiter.zustellungen'
import { Route as AngemeldetProjekteIndexRouteImport } from './routes/_angemeldet/projekte.index'
import { Route as AngemeldetProjekteIdRouteImport } from './routes/_angemeldet/projekte.$id'
import { Route as AngemeldetMitarbeiterAgenturVorschauKundeIdRouteImport } from './routes/_angemeldet/_mitarbeiter.agentur-vorschau.$kundeId'
import { Route as AngemeldetMitarbeiterAnfragenIdRouteImport } from './routes/_angemeldet/_mitarbeiter.anfragen.$id'
import { Route as AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRouteImport } from './routes/_angemeldet/_mitarbeiter.angebotsvorlagen.$vorlageId'
import { Route as AngemeldetMitarbeiterDrehvorbereitungIdRouteImport } from './routes/_angemeldet/_mitarbeiter.drehvorbereitung.$id'
import { Route as AngemeldetMitarbeiterEinstellungenKalkulationRouteImport } from './routes/_angemeldet/_mitarbeiter.einstellungen_.kalkulation'
import { Route as AngemeldetMitarbeiterKalkulatorKalkulationIdRouteImport } from './routes/_angemeldet/_mitarbeiter.kalkulator_.$kalkulationId'
import { Route as AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRouteImport } from './routes/_angemeldet/_mitarbeiter.anfragen.$id_.angebote.$angebotId'
import { Route as AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRouteImport } from './routes/_angemeldet/_mitarbeiter.anfragen.$id_.angebote.$angebotId_.vorschau'

const AngemeldetRoute = AngemeldetRouteImport.update({
  id: '/_angemeldet',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswortVergessenRoute = PasswortVergessenRouteImport.update({
  id: '/passwort-vergessen',
  path: '/passwort-vergessen',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswortZuruecksetzenRoute = PasswortZuruecksetzenRouteImport.update({
  id: '/passwort-zuruecksetzen',
  path: '/passwort-zuruecksetzen',
  getParentRoute: () => rootRouteImport,
} as any)
const AngemeldetIndexRoute = AngemeldetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetSplatRoute = AngemeldetSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetMitarbeiterRoute = AngemeldetMitarbeiterRouteImport.update({
  id: '/_mitarbeiter',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetAnfragenRoute = AngemeldetAnfragenRouteImport.update({
  id: '/anfragen',
  path: '/anfragen',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetAssistentRoute = AngemeldetAssistentRouteImport.update({
  id: '/assistent',
  path: '/assistent',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetBuchenRoute = AngemeldetBuchenRouteImport.update({
  id: '/buchen',
  path: '/buchen',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetEinrichtungRoute = AngemeldetEinrichtungRouteImport.update({
  id: '/einrichtung',
  path: '/einrichtung',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetFreigabenRoute = AngemeldetFreigabenRouteImport.update({
  id: '/freigaben',
  path: '/freigaben',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetKampagnenRoute = AngemeldetKampagnenRouteImport.update({
  id: '/kampagnen',
  path: '/kampagnen',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetKundenstimmenRoute = AngemeldetKundenstimmenRouteImport.update({
  id: '/kundenstimmen',
  path: '/kundenstimmen',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetProfilRoute = AngemeldetProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetRedaktionsplanRoute =
  AngemeldetRedaktionsplanRouteImport.update({
    id: '/redaktionsplan',
    path: '/redaktionsplan',
    getParentRoute: () => AngemeldetRoute,
  } as any)
const AngemeldetStatusRoute = AngemeldetStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetStudioRoute = AngemeldetStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetVorbereitungRoute = AngemeldetVorbereitungRouteImport.update({
  id: '/vorbereitung',
  path: '/vorbereitung',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngebotTokenRoute = AngebotTokenRouteImport.update({
  id: '/angebot/$token',
  path: '/angebot/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BuchenSlugRoute = BuchenSlugRouteImport.update({
  id: '/buchen/$slug',
  path: '/buchen/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BuchungTokenRoute = BuchungTokenRouteImport.update({
  id: '/buchung/$token',
  path: '/buchung/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DrehplanTokenRoute = DrehplanTokenRouteImport.update({
  id: '/drehplan/$token',
  path: '/drehplan/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewTokenRoute = ReviewTokenRouteImport.update({
  id: '/review/$token',
  path: '/review/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AngemeldetMitarbeiterAngeboteRoute =
  AngemeldetMitarbeiterAngeboteRouteImport.update({
    id: '/angebote',
    path: '/angebote',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterAufgabenRoute =
  AngemeldetMitarbeiterAufgabenRouteImport.update({
    id: '/aufgaben',
    path: '/aufgaben',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterBoardRoute =
  AngemeldetMitarbeiterBoardRouteImport.update({
    id: '/board',
    path: '/board',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterChatRoute =
  AngemeldetMitarbeiterChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterEinstellungenRoute =
  AngemeldetMitarbeiterEinstellungenRouteImport.update({
    id: '/einstellungen',
    path: '/einstellungen',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterErinnerungenRoute =
  AngemeldetMitarbeiterErinnerungenRouteImport.update({
    id: '/erinnerungen',
    path: '/erinnerungen',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterKalenderRoute =
  AngemeldetMitarbeiterKalenderRouteImport.update({
    id: '/kalender',
    path: '/kalender',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterKalkulatorRoute =
  AngemeldetMitarbeiterKalkulatorRouteImport.update({
    id: '/kalkulator',
    path: '/kalkulator',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterKundenRoute =
  AngemeldetMitarbeiterKundenRouteImport.update({
    id: '/kunden',
    path: '/kunden',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterOnboardingRoute =
  AngemeldetMitarbeiterOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterProduktionenRoute =
  AngemeldetMitarbeiterProduktionenRouteImport.update({
    id: '/produktionen',
    path: '/produktionen',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterTeamRoute =
  AngemeldetMitarbeiterTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterZustellungenRoute =
  AngemeldetMitarbeiterZustellungenRouteImport.update({
    id: '/zustellungen',
    path: '/zustellungen',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetProjekteIndexRoute = AngemeldetProjekteIndexRouteImport.update({
  id: '/projekte/',
  path: '/projekte/',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetProjekteIdRoute = AngemeldetProjekteIdRouteImport.update({
  id: '/projekte/$id',
  path: '/projekte/$id',
  getParentRoute: () => AngemeldetRoute,
} as any)
const AngemeldetMitarbeiterAgenturVorschauKundeIdRoute =
  AngemeldetMitarbeiterAgenturVorschauKundeIdRouteImport.update({
    id: '/agentur-vorschau/$kundeId',
    path: '/agentur-vorschau/$kundeId',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterAnfragenIdRoute =
  AngemeldetMitarbeiterAnfragenIdRouteImport.update({
    id: '/anfragen/$id',
    path: '/anfragen/$id',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute =
  AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRouteImport.update({
    id: '/angebotsvorlagen/$vorlageId',
    path: '/angebotsvorlagen/$vorlageId',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterDrehvorbereitungIdRoute =
  AngemeldetMitarbeiterDrehvorbereitungIdRouteImport.update({
    id: '/drehvorbereitung/$id',
    path: '/drehvorbereitung/$id',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterEinstellungenKalkulationRoute =
  AngemeldetMitarbeiterEinstellungenKalkulationRouteImport.update({
    id: '/einstellungen_/kalkulation',
    path: '/einstellungen/kalkulation',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterKalkulatorKalkulationIdRoute =
  AngemeldetMitarbeiterKalkulatorKalkulationIdRouteImport.update({
    id: '/kalkulator_/$kalkulationId',
    path: '/kalkulator/$kalkulationId',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute =
  AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRouteImport.update({
    id: '/anfragen/$id_/angebote/$angebotId',
    path: '/anfragen/$id/angebote/$angebotId',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)
const AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute =
  AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRouteImport.update({
    id: '/anfragen/$id_/angebote/$angebotId_/vorschau',
    path: '/anfragen/$id/angebote/$angebotId/vorschau',
    getParentRoute: () => AngemeldetMitarbeiterRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AngemeldetIndexRoute
  '/login': typeof LoginRoute
  '/passwort-vergessen': typeof PasswortVergessenRoute
  '/passwort-zuruecksetzen': typeof PasswortZuruecksetzenRoute
  '/$': typeof AngemeldetSplatRoute
  '/anfragen': typeof AngemeldetAnfragenRoute
  '/assistent': typeof AngemeldetAssistentRoute
  '/buchen': typeof AngemeldetBuchenRoute
  '/einrichtung': typeof AngemeldetEinrichtungRoute
  '/freigaben': typeof AngemeldetFreigabenRoute
  '/kampagnen': typeof AngemeldetKampagnenRoute
  '/kundenstimmen': typeof AngemeldetKundenstimmenRoute
  '/profil': typeof AngemeldetProfilRoute
  '/redaktionsplan': typeof AngemeldetRedaktionsplanRoute
  '/status': typeof AngemeldetStatusRoute
  '/studio': typeof AngemeldetStudioRoute
  '/vorbereitung': typeof AngemeldetVorbereitungRoute
  '/angebot/$token': typeof AngebotTokenRoute
  '/buchen/$slug': typeof BuchenSlugRoute
  '/buchung/$token': typeof BuchungTokenRoute
  '/drehplan/$token': typeof DrehplanTokenRoute
  '/review/$token': typeof ReviewTokenRoute
  '/angebote': typeof AngemeldetMitarbeiterAngeboteRoute
  '/aufgaben': typeof AngemeldetMitarbeiterAufgabenRoute
  '/board': typeof AngemeldetMitarbeiterBoardRoute
  '/chat': typeof AngemeldetMitarbeiterChatRoute
  '/einstellungen': typeof AngemeldetMitarbeiterEinstellungenRoute
  '/erinnerungen': typeof AngemeldetMitarbeiterErinnerungenRoute
  '/kalender': typeof AngemeldetMitarbeiterKalenderRoute
  '/kalkulator': typeof AngemeldetMitarbeiterKalkulatorRoute
  '/kunden': typeof AngemeldetMitarbeiterKundenRoute
  '/onboarding': typeof AngemeldetMitarbeiterOnboardingRoute
  '/produktionen': typeof AngemeldetMitarbeiterProduktionenRoute
  '/team': typeof AngemeldetMitarbeiterTeamRoute
  '/zustellungen': typeof AngemeldetMitarbeiterZustellungenRoute
  '/projekte/$id': typeof AngemeldetProjekteIdRoute
  '/projekte/': typeof AngemeldetProjekteIndexRoute
  '/agentur-vorschau/$kundeId': typeof AngemeldetMitarbeiterAgenturVorschauKundeIdRoute
  '/anfragen/$id': typeof AngemeldetMitarbeiterAnfragenIdRoute
  '/angebotsvorlagen/$vorlageId': typeof AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute
  '/drehvorbereitung/$id': typeof AngemeldetMitarbeiterDrehvorbereitungIdRoute
  '/einstellungen/kalkulation': typeof AngemeldetMitarbeiterEinstellungenKalkulationRoute
  '/kalkulator/$kalkulationId': typeof AngemeldetMitarbeiterKalkulatorKalkulationIdRoute
  '/anfragen/$id/angebote/$angebotId': typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute
  '/anfragen/$id/angebote/$angebotId/vorschau': typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/passwort-vergessen': typeof PasswortVergessenRoute
  '/passwort-zuruecksetzen': typeof PasswortZuruecksetzenRoute
  '/$': typeof AngemeldetSplatRoute
  '/': typeof AngemeldetIndexRoute
  '/anfragen': typeof AngemeldetAnfragenRoute
  '/assistent': typeof AngemeldetAssistentRoute
  '/buchen': typeof AngemeldetBuchenRoute
  '/einrichtung': typeof AngemeldetEinrichtungRoute
  '/freigaben': typeof AngemeldetFreigabenRoute
  '/kampagnen': typeof AngemeldetKampagnenRoute
  '/kundenstimmen': typeof AngemeldetKundenstimmenRoute
  '/profil': typeof AngemeldetProfilRoute
  '/redaktionsplan': typeof AngemeldetRedaktionsplanRoute
  '/status': typeof AngemeldetStatusRoute
  '/studio': typeof AngemeldetStudioRoute
  '/vorbereitung': typeof AngemeldetVorbereitungRoute
  '/angebot/$token': typeof AngebotTokenRoute
  '/buchen/$slug': typeof BuchenSlugRoute
  '/buchung/$token': typeof BuchungTokenRoute
  '/drehplan/$token': typeof DrehplanTokenRoute
  '/review/$token': typeof ReviewTokenRoute
  '/angebote': typeof AngemeldetMitarbeiterAngeboteRoute
  '/aufgaben': typeof AngemeldetMitarbeiterAufgabenRoute
  '/board': typeof AngemeldetMitarbeiterBoardRoute
  '/chat': typeof AngemeldetMitarbeiterChatRoute
  '/einstellungen': typeof AngemeldetMitarbeiterEinstellungenRoute
  '/erinnerungen': typeof AngemeldetMitarbeiterErinnerungenRoute
  '/kalender': typeof AngemeldetMitarbeiterKalenderRoute
  '/kalkulator': typeof AngemeldetMitarbeiterKalkulatorRoute
  '/kunden': typeof AngemeldetMitarbeiterKundenRoute
  '/onboarding': typeof AngemeldetMitarbeiterOnboardingRoute
  '/produktionen': typeof AngemeldetMitarbeiterProduktionenRoute
  '/team': typeof AngemeldetMitarbeiterTeamRoute
  '/zustellungen': typeof AngemeldetMitarbeiterZustellungenRoute
  '/projekte/$id': typeof AngemeldetProjekteIdRoute
  '/projekte': typeof AngemeldetProjekteIndexRoute
  '/agentur-vorschau/$kundeId': typeof AngemeldetMitarbeiterAgenturVorschauKundeIdRoute
  '/anfragen/$id': typeof AngemeldetMitarbeiterAnfragenIdRoute
  '/angebotsvorlagen/$vorlageId': typeof AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute
  '/drehvorbereitung/$id': typeof AngemeldetMitarbeiterDrehvorbereitungIdRoute
  '/einstellungen/kalkulation': typeof AngemeldetMitarbeiterEinstellungenKalkulationRoute
  '/kalkulator/$kalkulationId': typeof AngemeldetMitarbeiterKalkulatorKalkulationIdRoute
  '/anfragen/$id/angebote/$angebotId': typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute
  '/anfragen/$id/angebote/$angebotId/vorschau': typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_angemeldet': typeof AngemeldetRouteWithChildren
  '/login': typeof LoginRoute
  '/passwort-vergessen': typeof PasswortVergessenRoute
  '/passwort-zuruecksetzen': typeof PasswortZuruecksetzenRoute
  '/_angemeldet/$': typeof AngemeldetSplatRoute
  '/_angemeldet/_mitarbeiter': typeof AngemeldetMitarbeiterRouteWithChildren
  '/_angemeldet/anfragen': typeof AngemeldetAnfragenRoute
  '/_angemeldet/assistent': typeof AngemeldetAssistentRoute
  '/_angemeldet/buchen': typeof AngemeldetBuchenRoute
  '/_angemeldet/einrichtung': typeof AngemeldetEinrichtungRoute
  '/_angemeldet/freigaben': typeof AngemeldetFreigabenRoute
  '/_angemeldet/kampagnen': typeof AngemeldetKampagnenRoute
  '/_angemeldet/kundenstimmen': typeof AngemeldetKundenstimmenRoute
  '/_angemeldet/profil': typeof AngemeldetProfilRoute
  '/_angemeldet/redaktionsplan': typeof AngemeldetRedaktionsplanRoute
  '/_angemeldet/status': typeof AngemeldetStatusRoute
  '/_angemeldet/studio': typeof AngemeldetStudioRoute
  '/_angemeldet/vorbereitung': typeof AngemeldetVorbereitungRoute
  '/angebot/$token': typeof AngebotTokenRoute
  '/buchen/$slug': typeof BuchenSlugRoute
  '/buchung/$token': typeof BuchungTokenRoute
  '/drehplan/$token': typeof DrehplanTokenRoute
  '/review/$token': typeof ReviewTokenRoute
  '/_angemeldet/': typeof AngemeldetIndexRoute
  '/_angemeldet/_mitarbeiter/angebote': typeof AngemeldetMitarbeiterAngeboteRoute
  '/_angemeldet/_mitarbeiter/aufgaben': typeof AngemeldetMitarbeiterAufgabenRoute
  '/_angemeldet/_mitarbeiter/board': typeof AngemeldetMitarbeiterBoardRoute
  '/_angemeldet/_mitarbeiter/chat': typeof AngemeldetMitarbeiterChatRoute
  '/_angemeldet/_mitarbeiter/einstellungen': typeof AngemeldetMitarbeiterEinstellungenRoute
  '/_angemeldet/_mitarbeiter/erinnerungen': typeof AngemeldetMitarbeiterErinnerungenRoute
  '/_angemeldet/_mitarbeiter/kalender': typeof AngemeldetMitarbeiterKalenderRoute
  '/_angemeldet/_mitarbeiter/kalkulator': typeof AngemeldetMitarbeiterKalkulatorRoute
  '/_angemeldet/_mitarbeiter/kunden': typeof AngemeldetMitarbeiterKundenRoute
  '/_angemeldet/_mitarbeiter/onboarding': typeof AngemeldetMitarbeiterOnboardingRoute
  '/_angemeldet/_mitarbeiter/produktionen': typeof AngemeldetMitarbeiterProduktionenRoute
  '/_angemeldet/_mitarbeiter/team': typeof AngemeldetMitarbeiterTeamRoute
  '/_angemeldet/_mitarbeiter/zustellungen': typeof AngemeldetMitarbeiterZustellungenRoute
  '/_angemeldet/projekte/$id': typeof AngemeldetProjekteIdRoute
  '/_angemeldet/projekte/': typeof AngemeldetProjekteIndexRoute
  '/_angemeldet/_mitarbeiter/agentur-vorschau/$kundeId': typeof AngemeldetMitarbeiterAgenturVorschauKundeIdRoute
  '/_angemeldet/_mitarbeiter/anfragen/$id': typeof AngemeldetMitarbeiterAnfragenIdRoute
  '/_angemeldet/_mitarbeiter/angebotsvorlagen/$vorlageId': typeof AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute
  '/_angemeldet/_mitarbeiter/drehvorbereitung/$id': typeof AngemeldetMitarbeiterDrehvorbereitungIdRoute
  '/_angemeldet/_mitarbeiter/einstellungen_/kalkulation': typeof AngemeldetMitarbeiterEinstellungenKalkulationRoute
  '/_angemeldet/_mitarbeiter/kalkulator_/$kalkulationId': typeof AngemeldetMitarbeiterKalkulatorKalkulationIdRoute
  '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId': typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute
  '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId_/vorschau': typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/passwort-vergessen'
    | '/passwort-zuruecksetzen'
    | '/$'
    | '/anfragen'
    | '/assistent'
    | '/buchen'
    | '/einrichtung'
    | '/freigaben'
    | '/kampagnen'
    | '/kundenstimmen'
    | '/profil'
    | '/redaktionsplan'
    | '/status'
    | '/studio'
    | '/vorbereitung'
    | '/angebot/$token'
    | '/buchen/$slug'
    | '/buchung/$token'
    | '/drehplan/$token'
    | '/review/$token'
    | '/angebote'
    | '/aufgaben'
    | '/board'
    | '/chat'
    | '/einstellungen'
    | '/erinnerungen'
    | '/kalender'
    | '/kalkulator'
    | '/kunden'
    | '/onboarding'
    | '/produktionen'
    | '/team'
    | '/zustellungen'
    | '/projekte/$id'
    | '/projekte/'
    | '/agentur-vorschau/$kundeId'
    | '/anfragen/$id'
    | '/angebotsvorlagen/$vorlageId'
    | '/drehvorbereitung/$id'
    | '/einstellungen/kalkulation'
    | '/kalkulator/$kalkulationId'
    | '/anfragen/$id/angebote/$angebotId'
    | '/anfragen/$id/angebote/$angebotId/vorschau'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/passwort-vergessen'
    | '/passwort-zuruecksetzen'
    | '/$'
    | '/'
    | '/anfragen'
    | '/assistent'
    | '/buchen'
    | '/einrichtung'
    | '/freigaben'
    | '/kampagnen'
    | '/kundenstimmen'
    | '/profil'
    | '/redaktionsplan'
    | '/status'
    | '/studio'
    | '/vorbereitung'
    | '/angebot/$token'
    | '/buchen/$slug'
    | '/buchung/$token'
    | '/drehplan/$token'
    | '/review/$token'
    | '/angebote'
    | '/aufgaben'
    | '/board'
    | '/chat'
    | '/einstellungen'
    | '/erinnerungen'
    | '/kalender'
    | '/kalkulator'
    | '/kunden'
    | '/onboarding'
    | '/produktionen'
    | '/team'
    | '/zustellungen'
    | '/projekte/$id'
    | '/projekte'
    | '/agentur-vorschau/$kundeId'
    | '/anfragen/$id'
    | '/angebotsvorlagen/$vorlageId'
    | '/drehvorbereitung/$id'
    | '/einstellungen/kalkulation'
    | '/kalkulator/$kalkulationId'
    | '/anfragen/$id/angebote/$angebotId'
    | '/anfragen/$id/angebote/$angebotId/vorschau'
  id:
    | '__root__'
    | '/_angemeldet'
    | '/login'
    | '/passwort-vergessen'
    | '/passwort-zuruecksetzen'
    | '/_angemeldet/$'
    | '/_angemeldet/_mitarbeiter'
    | '/_angemeldet/anfragen'
    | '/_angemeldet/assistent'
    | '/_angemeldet/buchen'
    | '/_angemeldet/einrichtung'
    | '/_angemeldet/freigaben'
    | '/_angemeldet/kampagnen'
    | '/_angemeldet/kundenstimmen'
    | '/_angemeldet/profil'
    | '/_angemeldet/redaktionsplan'
    | '/_angemeldet/status'
    | '/_angemeldet/studio'
    | '/_angemeldet/vorbereitung'
    | '/angebot/$token'
    | '/buchen/$slug'
    | '/buchung/$token'
    | '/drehplan/$token'
    | '/review/$token'
    | '/_angemeldet/'
    | '/_angemeldet/_mitarbeiter/angebote'
    | '/_angemeldet/_mitarbeiter/aufgaben'
    | '/_angemeldet/_mitarbeiter/board'
    | '/_angemeldet/_mitarbeiter/chat'
    | '/_angemeldet/_mitarbeiter/einstellungen'
    | '/_angemeldet/_mitarbeiter/erinnerungen'
    | '/_angemeldet/_mitarbeiter/kalender'
    | '/_angemeldet/_mitarbeiter/kalkulator'
    | '/_angemeldet/_mitarbeiter/kunden'
    | '/_angemeldet/_mitarbeiter/onboarding'
    | '/_angemeldet/_mitarbeiter/produktionen'
    | '/_angemeldet/_mitarbeiter/team'
    | '/_angemeldet/_mitarbeiter/zustellungen'
    | '/_angemeldet/projekte/$id'
    | '/_angemeldet/projekte/'
    | '/_angemeldet/_mitarbeiter/agentur-vorschau/$kundeId'
    | '/_angemeldet/_mitarbeiter/anfragen/$id'
    | '/_angemeldet/_mitarbeiter/angebotsvorlagen/$vorlageId'
    | '/_angemeldet/_mitarbeiter/drehvorbereitung/$id'
    | '/_angemeldet/_mitarbeiter/einstellungen_/kalkulation'
    | '/_angemeldet/_mitarbeiter/kalkulator_/$kalkulationId'
    | '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId'
    | '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId_/vorschau'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AngemeldetRoute: typeof AngemeldetRouteWithChildren
  LoginRoute: typeof LoginRoute
  PasswortVergessenRoute: typeof PasswortVergessenRoute
  PasswortZuruecksetzenRoute: typeof PasswortZuruecksetzenRoute
  AngebotTokenRoute: typeof AngebotTokenRoute
  BuchenSlugRoute: typeof BuchenSlugRoute
  BuchungTokenRoute: typeof BuchungTokenRoute
  DrehplanTokenRoute: typeof DrehplanTokenRoute
  ReviewTokenRoute: typeof ReviewTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_angemeldet': {
      id: '/_angemeldet'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AngemeldetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passwort-vergessen': {
      id: '/passwort-vergessen'
      path: '/passwort-vergessen'
      fullPath: '/passwort-vergessen'
      preLoaderRoute: typeof PasswortVergessenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passwort-zuruecksetzen': {
      id: '/passwort-zuruecksetzen'
      path: '/passwort-zuruecksetzen'
      fullPath: '/passwort-zuruecksetzen'
      preLoaderRoute: typeof PasswortZuruecksetzenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_angemeldet/': {
      id: '/_angemeldet/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AngemeldetIndexRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/$': {
      id: '/_angemeldet/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AngemeldetSplatRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/_mitarbeiter': {
      id: '/_angemeldet/_mitarbeiter'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AngemeldetMitarbeiterRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/anfragen': {
      id: '/_angemeldet/anfragen'
      path: '/anfragen'
      fullPath: '/anfragen'
      preLoaderRoute: typeof AngemeldetAnfragenRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/assistent': {
      id: '/_angemeldet/assistent'
      path: '/assistent'
      fullPath: '/assistent'
      preLoaderRoute: typeof AngemeldetAssistentRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/buchen': {
      id: '/_angemeldet/buchen'
      path: '/buchen'
      fullPath: '/buchen'
      preLoaderRoute: typeof AngemeldetBuchenRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/einrichtung': {
      id: '/_angemeldet/einrichtung'
      path: '/einrichtung'
      fullPath: '/einrichtung'
      preLoaderRoute: typeof AngemeldetEinrichtungRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/freigaben': {
      id: '/_angemeldet/freigaben'
      path: '/freigaben'
      fullPath: '/freigaben'
      preLoaderRoute: typeof AngemeldetFreigabenRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/kampagnen': {
      id: '/_angemeldet/kampagnen'
      path: '/kampagnen'
      fullPath: '/kampagnen'
      preLoaderRoute: typeof AngemeldetKampagnenRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/kundenstimmen': {
      id: '/_angemeldet/kundenstimmen'
      path: '/kundenstimmen'
      fullPath: '/kundenstimmen'
      preLoaderRoute: typeof AngemeldetKundenstimmenRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/profil': {
      id: '/_angemeldet/profil'
      path: '/profil'
      fullPath: '/profil'
      preLoaderRoute: typeof AngemeldetProfilRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/redaktionsplan': {
      id: '/_angemeldet/redaktionsplan'
      path: '/redaktionsplan'
      fullPath: '/redaktionsplan'
      preLoaderRoute: typeof AngemeldetRedaktionsplanRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/status': {
      id: '/_angemeldet/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof AngemeldetStatusRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/studio': {
      id: '/_angemeldet/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof AngemeldetStudioRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/vorbereitung': {
      id: '/_angemeldet/vorbereitung'
      path: '/vorbereitung'
      fullPath: '/vorbereitung'
      preLoaderRoute: typeof AngemeldetVorbereitungRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/angebot/$token': {
      id: '/angebot/$token'
      path: '/angebot/$token'
      fullPath: '/angebot/$token'
      preLoaderRoute: typeof AngebotTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buchen/$slug': {
      id: '/buchen/$slug'
      path: '/buchen/$slug'
      fullPath: '/buchen/$slug'
      preLoaderRoute: typeof BuchenSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buchung/$token': {
      id: '/buchung/$token'
      path: '/buchung/$token'
      fullPath: '/buchung/$token'
      preLoaderRoute: typeof BuchungTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drehplan/$token': {
      id: '/drehplan/$token'
      path: '/drehplan/$token'
      fullPath: '/drehplan/$token'
      preLoaderRoute: typeof DrehplanTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/$token': {
      id: '/review/$token'
      path: '/review/$token'
      fullPath: '/review/$token'
      preLoaderRoute: typeof ReviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_angemeldet/_mitarbeiter/angebote': {
      id: '/_angemeldet/_mitarbeiter/angebote'
      path: '/angebote'
      fullPath: '/angebote'
      preLoaderRoute: typeof AngemeldetMitarbeiterAngeboteRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/aufgaben': {
      id: '/_angemeldet/_mitarbeiter/aufgaben'
      path: '/aufgaben'
      fullPath: '/aufgaben'
      preLoaderRoute: typeof AngemeldetMitarbeiterAufgabenRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/board': {
      id: '/_angemeldet/_mitarbeiter/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof AngemeldetMitarbeiterBoardRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/chat': {
      id: '/_angemeldet/_mitarbeiter/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AngemeldetMitarbeiterChatRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/einstellungen': {
      id: '/_angemeldet/_mitarbeiter/einstellungen'
      path: '/einstellungen'
      fullPath: '/einstellungen'
      preLoaderRoute: typeof AngemeldetMitarbeiterEinstellungenRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/erinnerungen': {
      id: '/_angemeldet/_mitarbeiter/erinnerungen'
      path: '/erinnerungen'
      fullPath: '/erinnerungen'
      preLoaderRoute: typeof AngemeldetMitarbeiterErinnerungenRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/kalender': {
      id: '/_angemeldet/_mitarbeiter/kalender'
      path: '/kalender'
      fullPath: '/kalender'
      preLoaderRoute: typeof AngemeldetMitarbeiterKalenderRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/kalkulator': {
      id: '/_angemeldet/_mitarbeiter/kalkulator'
      path: '/kalkulator'
      fullPath: '/kalkulator'
      preLoaderRoute: typeof AngemeldetMitarbeiterKalkulatorRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/kunden': {
      id: '/_angemeldet/_mitarbeiter/kunden'
      path: '/kunden'
      fullPath: '/kunden'
      preLoaderRoute: typeof AngemeldetMitarbeiterKundenRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/onboarding': {
      id: '/_angemeldet/_mitarbeiter/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AngemeldetMitarbeiterOnboardingRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/produktionen': {
      id: '/_angemeldet/_mitarbeiter/produktionen'
      path: '/produktionen'
      fullPath: '/produktionen'
      preLoaderRoute: typeof AngemeldetMitarbeiterProduktionenRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/team': {
      id: '/_angemeldet/_mitarbeiter/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AngemeldetMitarbeiterTeamRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/zustellungen': {
      id: '/_angemeldet/_mitarbeiter/zustellungen'
      path: '/zustellungen'
      fullPath: '/zustellungen'
      preLoaderRoute: typeof AngemeldetMitarbeiterZustellungenRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/projekte/': {
      id: '/_angemeldet/projekte/'
      path: '/projekte'
      fullPath: '/projekte/'
      preLoaderRoute: typeof AngemeldetProjekteIndexRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/projekte/$id': {
      id: '/_angemeldet/projekte/$id'
      path: '/projekte/$id'
      fullPath: '/projekte/$id'
      preLoaderRoute: typeof AngemeldetProjekteIdRouteImport
      parentRoute: typeof AngemeldetRoute
    }
    '/_angemeldet/_mitarbeiter/agentur-vorschau/$kundeId': {
      id: '/_angemeldet/_mitarbeiter/agentur-vorschau/$kundeId'
      path: '/agentur-vorschau/$kundeId'
      fullPath: '/agentur-vorschau/$kundeId'
      preLoaderRoute: typeof AngemeldetMitarbeiterAgenturVorschauKundeIdRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/anfragen/$id': {
      id: '/_angemeldet/_mitarbeiter/anfragen/$id'
      path: '/anfragen/$id'
      fullPath: '/anfragen/$id'
      preLoaderRoute: typeof AngemeldetMitarbeiterAnfragenIdRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/angebotsvorlagen/$vorlageId': {
      id: '/_angemeldet/_mitarbeiter/angebotsvorlagen/$vorlageId'
      path: '/angebotsvorlagen/$vorlageId'
      fullPath: '/angebotsvorlagen/$vorlageId'
      preLoaderRoute: typeof AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/drehvorbereitung/$id': {
      id: '/_angemeldet/_mitarbeiter/drehvorbereitung/$id'
      path: '/drehvorbereitung/$id'
      fullPath: '/drehvorbereitung/$id'
      preLoaderRoute: typeof AngemeldetMitarbeiterDrehvorbereitungIdRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/einstellungen_/kalkulation': {
      id: '/_angemeldet/_mitarbeiter/einstellungen_/kalkulation'
      path: '/einstellungen/kalkulation'
      fullPath: '/einstellungen/kalkulation'
      preLoaderRoute: typeof AngemeldetMitarbeiterEinstellungenKalkulationRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/kalkulator_/$kalkulationId': {
      id: '/_angemeldet/_mitarbeiter/kalkulator_/$kalkulationId'
      path: '/kalkulator/$kalkulationId'
      fullPath: '/kalkulator/$kalkulationId'
      preLoaderRoute: typeof AngemeldetMitarbeiterKalkulatorKalkulationIdRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId': {
      id: '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId'
      path: '/anfragen/$id/angebote/$angebotId'
      fullPath: '/anfragen/$id/angebote/$angebotId'
      preLoaderRoute: typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
    '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId_/vorschau': {
      id: '/_angemeldet/_mitarbeiter/anfragen/$id_/angebote/$angebotId_/vorschau'
      path: '/anfragen/$id/angebote/$angebotId/vorschau'
      fullPath: '/anfragen/$id/angebote/$angebotId/vorschau'
      preLoaderRoute: typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRouteImport
      parentRoute: typeof AngemeldetMitarbeiterRoute
    }
  }
}

interface AngemeldetMitarbeiterRouteChildren {
  AngemeldetMitarbeiterAngeboteRoute: typeof AngemeldetMitarbeiterAngeboteRoute
  AngemeldetMitarbeiterAufgabenRoute: typeof AngemeldetMitarbeiterAufgabenRoute
  AngemeldetMitarbeiterBoardRoute: typeof AngemeldetMitarbeiterBoardRoute
  AngemeldetMitarbeiterChatRoute: typeof AngemeldetMitarbeiterChatRoute
  AngemeldetMitarbeiterEinstellungenRoute: typeof AngemeldetMitarbeiterEinstellungenRoute
  AngemeldetMitarbeiterErinnerungenRoute: typeof AngemeldetMitarbeiterErinnerungenRoute
  AngemeldetMitarbeiterKalenderRoute: typeof AngemeldetMitarbeiterKalenderRoute
  AngemeldetMitarbeiterKalkulatorRoute: typeof AngemeldetMitarbeiterKalkulatorRoute
  AngemeldetMitarbeiterKundenRoute: typeof AngemeldetMitarbeiterKundenRoute
  AngemeldetMitarbeiterOnboardingRoute: typeof AngemeldetMitarbeiterOnboardingRoute
  AngemeldetMitarbeiterProduktionenRoute: typeof AngemeldetMitarbeiterProduktionenRoute
  AngemeldetMitarbeiterTeamRoute: typeof AngemeldetMitarbeiterTeamRoute
  AngemeldetMitarbeiterZustellungenRoute: typeof AngemeldetMitarbeiterZustellungenRoute
  AngemeldetMitarbeiterAgenturVorschauKundeIdRoute: typeof AngemeldetMitarbeiterAgenturVorschauKundeIdRoute
  AngemeldetMitarbeiterAnfragenIdRoute: typeof AngemeldetMitarbeiterAnfragenIdRoute
  AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute: typeof AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute
  AngemeldetMitarbeiterDrehvorbereitungIdRoute: typeof AngemeldetMitarbeiterDrehvorbereitungIdRoute
  AngemeldetMitarbeiterEinstellungenKalkulationRoute: typeof AngemeldetMitarbeiterEinstellungenKalkulationRoute
  AngemeldetMitarbeiterKalkulatorKalkulationIdRoute: typeof AngemeldetMitarbeiterKalkulatorKalkulationIdRoute
  AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute: typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute
  AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute: typeof AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute
}

const AngemeldetMitarbeiterRouteChildren: AngemeldetMitarbeiterRouteChildren = {
  AngemeldetMitarbeiterAngeboteRoute: AngemeldetMitarbeiterAngeboteRoute,
  AngemeldetMitarbeiterAufgabenRoute: AngemeldetMitarbeiterAufgabenRoute,
  AngemeldetMitarbeiterBoardRoute: AngemeldetMitarbeiterBoardRoute,
  AngemeldetMitarbeiterChatRoute: AngemeldetMitarbeiterChatRoute,
  AngemeldetMitarbeiterEinstellungenRoute:
    AngemeldetMitarbeiterEinstellungenRoute,
  AngemeldetMitarbeiterErinnerungenRoute:
    AngemeldetMitarbeiterErinnerungenRoute,
  AngemeldetMitarbeiterKalenderRoute: AngemeldetMitarbeiterKalenderRoute,
  AngemeldetMitarbeiterKalkulatorRoute: AngemeldetMitarbeiterKalkulatorRoute,
  AngemeldetMitarbeiterKundenRoute: AngemeldetMitarbeiterKundenRoute,
  AngemeldetMitarbeiterOnboardingRoute: AngemeldetMitarbeiterOnboardingRoute,
  AngemeldetMitarbeiterProduktionenRoute:
    AngemeldetMitarbeiterProduktionenRoute,
  AngemeldetMitarbeiterTeamRoute: AngemeldetMitarbeiterTeamRoute,
  AngemeldetMitarbeiterZustellungenRoute:
    AngemeldetMitarbeiterZustellungenRoute,
  AngemeldetMitarbeiterAgenturVorschauKundeIdRoute:
    AngemeldetMitarbeiterAgenturVorschauKundeIdRoute,
  AngemeldetMitarbeiterAnfragenIdRoute: AngemeldetMitarbeiterAnfragenIdRoute,
  AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute:
    AngemeldetMitarbeiterAngebotsvorlagenVorlageIdRoute,
  AngemeldetMitarbeiterDrehvorbereitungIdRoute:
    AngemeldetMitarbeiterDrehvorbereitungIdRoute,
  AngemeldetMitarbeiterEinstellungenKalkulationRoute:
    AngemeldetMitarbeiterEinstellungenKalkulationRoute,
  AngemeldetMitarbeiterKalkulatorKalkulationIdRoute:
    AngemeldetMitarbeiterKalkulatorKalkulationIdRoute,
  AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute:
    AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdRoute,
  AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute:
    AngemeldetMitarbeiterAnfragenIdAngeboteAngebotIdVorschauRoute,
}

const AngemeldetMitarbeiterRouteWithChildren =
  AngemeldetMitarbeiterRoute._addFileChildren(
    AngemeldetMitarbeiterRouteChildren,
  )

interface AngemeldetRouteChildren {
  AngemeldetSplatRoute: typeof AngemeldetSplatRoute
  AngemeldetMitarbeiterRoute: typeof AngemeldetMitarbeiterRouteWithChildren
  AngemeldetAnfragenRoute: typeof AngemeldetAnfragenRoute
  AngemeldetAssistentRoute: typeof AngemeldetAssistentRoute
  AngemeldetBuchenRoute: typeof AngemeldetBuchenRoute
  AngemeldetEinrichtungRoute: typeof AngemeldetEinrichtungRoute
  AngemeldetFreigabenRoute: typeof AngemeldetFreigabenRoute
  AngemeldetKampagnenRoute: typeof AngemeldetKampagnenRoute
  AngemeldetKundenstimmenRoute: typeof AngemeldetKundenstimmenRoute
  AngemeldetProfilRoute: typeof AngemeldetProfilRoute
  AngemeldetRedaktionsplanRoute: typeof AngemeldetRedaktionsplanRoute
  AngemeldetStatusRoute: typeof AngemeldetStatusRoute
  AngemeldetStudioRoute: typeof AngemeldetStudioRoute
  AngemeldetVorbereitungRoute: typeof AngemeldetVorbereitungRoute
  AngemeldetIndexRoute: typeof AngemeldetIndexRoute
  AngemeldetProjekteIdRoute: typeof AngemeldetProjekteIdRoute
  AngemeldetProjekteIndexRoute: typeof AngemeldetProjekteIndexRoute
}

const AngemeldetRouteChildren: AngemeldetRouteChildren = {
  AngemeldetSplatRoute: AngemeldetSplatRoute,
  AngemeldetMitarbeiterRoute: AngemeldetMitarbeiterRouteWithChildren,
  AngemeldetAnfragenRoute: AngemeldetAnfragenRoute,
  AngemeldetAssistentRoute: AngemeldetAssistentRoute,
  AngemeldetBuchenRoute: AngemeldetBuchenRoute,
  AngemeldetEinrichtungRoute: AngemeldetEinrichtungRoute,
  AngemeldetFreigabenRoute: AngemeldetFreigabenRoute,
  AngemeldetKampagnenRoute: AngemeldetKampagnenRoute,
  AngemeldetKundenstimmenRoute: AngemeldetKundenstimmenRoute,
  AngemeldetProfilRoute: AngemeldetProfilRoute,
  AngemeldetRedaktionsplanRoute: AngemeldetRedaktionsplanRoute,
  AngemeldetStatusRoute: AngemeldetStatusRoute,
  AngemeldetStudioRoute: AngemeldetStudioRoute,
  AngemeldetVorbereitungRoute: AngemeldetVorbereitungRoute,
  AngemeldetIndexRoute: AngemeldetIndexRoute,
  AngemeldetProjekteIdRoute: AngemeldetProjekteIdRoute,
  AngemeldetProjekteIndexRoute: AngemeldetProjekteIndexRoute,
}

const AngemeldetRouteWithChildren = AngemeldetRoute._addFileChildren(
  AngemeldetRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AngemeldetRoute: AngemeldetRouteWithChildren,
  LoginRoute: LoginRoute,
  PasswortVergessenRoute: PasswortVergessenRoute,
  PasswortZuruecksetzenRoute: PasswortZuruecksetzenRoute,
  AngebotTokenRoute: AngebotTokenRoute,
  BuchenSlugRoute: BuchenSlugRoute,
  BuchungTokenRoute: BuchungTokenRoute,
  DrehplanTokenRoute: DrehplanTokenRoute,
  ReviewTokenRoute: ReviewTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
